import { render, staticRenderFns } from "./PersonContentLoader.vue?vue&type=template&id=71b17175&scoped=true"
import script from "./PersonContentLoader.vue?vue&type=script&lang=js"
export * from "./PersonContentLoader.vue?vue&type=script&lang=js"
import style0 from "./PersonContentLoader.vue?vue&type=style&index=0&id=71b17175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b17175",
  null
  
)

export default component.exports